<template>
  <div class="status-outer-container" :class="{ dark: dark }">
    <div class="status-container" :class="{ dark: dark }">
      <div class="status-card">
        <div class="status-card-content">
          <div class="status-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="38" height="38" aria-label="Ícone de livro">
              <path d="M329.4 433l217.7-43.5c7.5-1.5 12.9-8.1 12.9-15.7l0-340.3c0-9.7-8.6-17.2-18.2-15.9L328 47.1l0 386.2c.5-.1 .9-.2 1.4-.3zm-17.4 .3l0-386.2L98.2 17.7C88.6 16.3 80 23.8 80 33.5l0 340.3c0 7.6 5.4 14.2 12.9 15.7L310.6 433c.5 .1 .9 .2 1.4 .3zM539.6 1.8C558.9-.8 576 14.1 576 33.5l0 340.3c0 15.3-10.8 28.4-25.7 31.4L332.6 448.7c-8.3 1.7-16.8 1.7-25.1 0L89.7 405.1c-15-3-25.7-16.1-25.7-31.4L64 33.5C64 14.1 81.1-.8 100.4 1.8L320 32 539.6 1.8zM0 65.5c0-17.9 14.6-32 32-32l0 16c-8.7 0-16 7-16 16l0 353.1c0 7.6 5.4 14.2 12.9 15.7l281.7 56.3c6.2 1.2 12.6 1.2 18.8 0l281.7-56.3c7.5-1.5 12.9-8.1 12.9-15.7l0-353.1c0-9-7.3-16-16-16l0-16c17.4 0 32 14.1 32 32l0 353.1c0 15.3-10.8 28.4-25.7 31.4L332.6 506.3c-8.3 1.7-16.8 1.7-25.1 0L25.7 449.9C10.8 447 0 433.8 0 418.6L0 65.5z"/>
            </svg>
          </div>
          <div class="status-title">
            <span v-html="mensagemStatus.titulo"></span>
          </div>
          <div class="status-desc">
            <span v-html="mensagemStatus.descricao"></span>
          </div>
          <div class="status-days">
            <button
              v-for="(dia, idx) in diasSemanaPadrao"
              :key="dia.day"
              :class="[
                { 'has-aula': dia.totalMinutes > 0 }
              ]"
              @click="selecionarDia(idx)"
            >
              {{ dia.day }}
              <span
                v-if="dia.totalMinutes > 0"
                class="aula-dot"
                :title="'Aula assistida neste dia'"
              ></span>
              <span
                v-else
                class="aula-dot"
                style="opacity:0.3"
                :title="'Nenhuma aula assistida neste dia'"
              ></span>
            </button>
          </div>
        </div>
      </div>
      <div class="status-graph-card">
        <div class="status-graph-header">
          <span class="graph-title">Tempo de Estudo</span>
          <span class="graph-average">
            Média diária<br />
            <span class="graph-average-time">{{ mediaDiaria }}</span>
          </span>
        </div>
        <div class="status-graph">
          <Bar
            :data="chartData"
            :options="chartOptions"
            :height="120"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Bar } from 'vue-chartjs'
import {
  Chart,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
} from 'chart.js'
import status from '@/utils/portal/status';

Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title);

const DIAS_SEMANA_PADRAO = [
  { day: "Seg", date: null, totalMinutes: 0 },
  { day: "Ter", date: null, totalMinutes: 0 },
  { day: "Qua", date: null, totalMinutes: 0 },
  { day: "Qui", date: null, totalMinutes: 0 },
  { day: "Sex", date: null, totalMinutes: 0 },
  { day: "Sáb", date: null, totalMinutes: 0 },
  { day: "Dom", date: null, totalMinutes: 0 }
];

export default {
  components: {
    Bar
  },
  data() {
    return {
      diasSemana: [],
      selectedDay: 0,
    }
  },
  computed: {
    ...mapState(['dark','token']),
    diasSemanaPadrao() {
      const mapDias = {};
      this.diasSemana.forEach(d => {
        mapDias[d.day] = d;
      });
      return DIAS_SEMANA_PADRAO.map((padrao, idx) => {
        if (mapDias[padrao.day]) {
          return {
            ...padrao,
            ...mapDias[padrao.day]
          }
        } else {
          return { ...padrao }
        }
      });
    },
    mediaDiaria() {
      const diasComEstudo = this.diasSemanaPadrao.filter(d => d.totalMinutes > 0);
      if (diasComEstudo.length === 0) {
        return '0 h';
      } else if (diasComEstudo.length === 1) {
        const horas = Math.floor(diasComEstudo[0].totalMinutes / 60);
        return `${horas} h`;
      } else {
        const total = diasComEstudo.reduce((a, b) => a + (b.totalMinutes || 0), 0);
        const media = Math.round(total / diasComEstudo.length);
        const horas = Math.floor(media / 60);
        return `${horas} h`;
      }
    },
    chartData() {
      return {
        labels: this.diasSemanaPadrao.map(d => d.day),
        datasets: [
          {
            label: 'Horas de estudo',
            data: this.diasSemanaPadrao.map(d => Math.floor((d.totalMinutes || 0) / 60)),
            backgroundColor: [
              '#19c7d0', '#19c7d0', '#19c7d0', '#19c7d0', '#19c7d0', '#19c7d0', '#19c7d0'
            ],
            borderRadius: 6,
            barPercentage: 0.7,
            categoryPercentage: 0.7,
          }
        ]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                return `${context.parsed.y}h`;
              }
            }
          },
          title: {
            display: false
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: this.dark ? '#b4b1ad' : '#888',
              font: {
                size: 13
              }
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: this.dark ? '#23272f' : '#ebebeb'
            },
            ticks: {
              color: this.dark ? '#b4b1ad' : '#888',
              font: {
                size: 13
              },
              stepSize: 1,
              callback: function(value) {
                return value + 'h';
              }
            }
          }
        }
      }
    },
    mensagemStatus() {
      let hoje = new Date();
      let diaSemana = hoje.getDay();
      if (diaSemana === 0) diaSemana = 7;

      const diasEstudados = this.diasSemanaPadrao.filter(d => d.totalMinutes > 0).length;

      if (diaSemana == 1) {
        return {
          titulo: "<span>Primeiro dia</span>, parabéns!",
          descricao: "Começar é sempre o passo mais importante!"
        }
      } else if (diaSemana == 2) {
        if (diasEstudados == 2) {
          return {
            titulo: "<span>2 dias</span> de estudo! Continue com esse ritmo!",
            descricao: "Você está indo muito bem, não pare agora!"
          }
        } else {
          return {
            titulo: "<span>Ótimo começo</span>, primeiro dia de estudo!",
            descricao: "Você deu o primeiro passo! Mantenha o foco e a determinação!"
          }
        }
      } else if (diaSemana == 3) {
        if (diasEstudados == 3) {
          return {
            titulo: "<span>3 dias</span> seguidos de estudo",
            descricao: "Você está criando uma rotina sólida. Continue firme!"
          }
        } else {
          return {
            titulo: "<span>Bom trabalho!</span> Continue assim!",
            descricao: "O esforço de hoje será a vitória de amanhã!"
          }
        }
      } else if (diaSemana == 4) {
        if (diasEstudados == 4) {
          return {
            titulo: "<span>4 dias</span> de foco total",
            descricao: "Cada dia é um passo mais perto do sucesso!"
          }
        } else {
          return {
            titulo: "<span>Bom trabalho!</span> Continue assim!",
            descricao: "Você está mais perto dos seus objetivos!"
          }
        }
      } else if (diaSemana == 5) {
        if (diasEstudados == 5) {
          return {
            titulo: "<span>5 dias</span> de dedicação",
            descricao: "Você está mostrando determinação!"
          }
        } else {
          return {
            titulo: "<span>Bom trabalho!</span> Continue assim!",
            descricao: "Você está mais perto dos seus objetivos!"
          }
        }
      } else if (diaSemana == 6) {
        return {
          titulo: "<span>Sábado</span> de estudo, ótimo trabalho",
          descricao: "Você está aproveitando o fim de semana para se dedicar!"
        }
      } else if (diaSemana == 7) {
        return {
          titulo: "<span>Domingo</span> de foco, parabéns pela dedicação!",
          descricao: "Você está fazendo a diferença no seu domingo"
        }
      } else {
        return {
          titulo: "<span>Continue!</span>",
          descricao: "Mantenha o ritmo e siga estudando!"
        }
      }
    }
  },
  methods: {
    selecionarDia(idx) {
      this.selectedDay = idx;
    },
    async getDataStatus(){
      const response = await status.getDataStatus(this.token);
      if(response && response.length > 0){
        const mapDias = {};
        response.forEach(d => {
          mapDias[d.day] = d;
        });
        this.diasSemana = DIAS_SEMANA_PADRAO.map(padrao => {
          if (mapDias[padrao.day]) {
            return {
              ...padrao,
              ...mapDias[padrao.day]
            }
          } else {
            return { ...padrao }
          }
        });
      } else {
        this.diasSemana = DIAS_SEMANA_PADRAO.map(padrao => ({ ...padrao }));
      }
    }
  },
  created(){
    this.getDataStatus();
  }
}
</script>

<style scoped>
@import './index.css';
</style>
